import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useHistory } from 'react-router-dom'
import { useModal } from '../providers/modal-provider.js';
import { useAuthData } from '../includes/auth-provider.js';
import swal from 'sweetalert';
import QRCode from 'qrcode';
import { getCookie } from '../common_component/cookie.js';
import PageLoader from "../common_component/PageLoader.js";

export default function ProductQrGeneratorModal() {

    const { displayModal, modalData, closeModal, setModalData, setModalView } = useModal()
    const [loading, setLoading] = useState(false);
    const [qrFor, setQrFor] = useState([]);
    const [pageSize, setPageSize] = useState("A4");
    const [stockInformation, setStockInformation] = useState([]);
    const [quantityAdjust, setQuantityAdjust] = useState(0);

    const { user, write, organization_id } = useAuthData(modalData.page_name);
    const history = useHistory();

    async function getDefaultQrGeneartionSettings() {
        setLoading(true);
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-default-bulk-qr-generation-setting`, { method: 'POST', body: JSON.stringify({ "organization_id": organization_id, "email": user.email, "page_name": modalData.page_name }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.data.defaultSetting !== null) {
            const temp = body.data.defaultSetting.settings.find(x => x.type == "Product").qrFor;
            setQrFor(temp);
            setPageSize(body.data.pageSize);
            setLoading(false);
        }
        else {
            swal({
                title: "Oh!",
                text: "You need to set QR settings first!",
                icon: "warning",
                buttons: {
                    cancel: "Close",
                    confirm: {
                        text: "Go to Settings",
                        value: true,
                    },
                },
            }).then((result) => {
                if (result) {
                    handleProductQrModalClose();
                    history.push("/bulk-qr-generation-settings");
                } else {
                    handleProductQrModalClose();
                }
            });
        }
    }

    const handleProductQrModalClose = () => {
        closeModal()
        setModalView(null)
        setModalData(null)
    }

    useEffect(() => {
        setQuantityAdjust(modalData.available_stock);
        setStockInformation(modalData.serial_batch_details);
        getDefaultQrGeneartionSettings();
    }, [])

    const directPrintQRWithImage = async (qrData = [], pageSize = "A4") => {
        const printWindow = window.open('', '_blank', 'width=800,height=600');
        if (!printWindow) return alert("Popup blocked. Please allow popups.");

        const base64Images = await Promise.all(
            qrData.map(qr => QRCode.toDataURL(qr.text))
        );

        const html = `
    <html>
    <head>
        <title>QR Print</title>
        <style>
            body { font-family: sans-serif; margin: 0; padding: 20px; }
            .grid { display: flex; flex-wrap: wrap; gap: 12px; }
            .qr-box {
                width: ${pageSize === "A4" ? "23%" : "30%"};
                text-align: center;
                page-break-inside: avoid;
            }
            .qr-box img {
                width: 128px;
                height: 128px;
            }
            .qr-box .label {
                font-size: 12px;
                margin-top: 5px;
            }
        </style>
    </head>
    <body>
        <div class="grid">
            ${qrData.map((qr, i) => `
                <div class="qr-box">
                    <img src="${base64Images[i]}" />
                    <div class="label">${qr.label}</div>
                </div>
            `).join("")}
        </div>
        <script>
            window.onload = () => {
                setTimeout(() => {
                    window.print();
                    window.close();
                }, 300);
            };
        </script>
    </body>
    </html>`;

        printWindow.document.write(html);
        printWindow.document.close();
    };

    const handlePrintQR = () => {
        const qrData = [];

        if (modalData.tracking_inventory_type === "Track Batches" && qrFor.includes("Serial/Batch Details")) {
            stockInformation
                .filter(item => item.checked)
                .forEach(item => {
                    const quantity = parseInt(item.Quantity, 10) || 0;
                    for (let i = 0; i < quantity; i++) {
                        qrData.push({
                            uid: `${modalData.pid}-${item.Batch_Reference}-${i + 1}`,
                            text: `Pid:${modalData.pid} | Pname:${modalData.product_name} | Ptype:${modalData.tracking_inventory_type} | Batch:${item.Batch_Reference} | Batch_uid:${item.uid}`,
                            label: `${modalData.product_name} (Batch: ${item.Batch_Reference})`
                        });
                    }
                });
        } else if (modalData.tracking_inventory_type === "Track Serial Number" && qrFor.includes("Serial/Batch Details")) {
            stockInformation
                .filter(item => item.checked)
                .forEach(item => {
                    qrData.push({
                        uid: `${modalData.pid}-${item.serialName}`,
                        text: `Pid:${modalData.pid} | Pname:${modalData.product_name} | Ptype:${modalData.tracking_inventory_type}  | Serial:${item.serialName} | Serial_uid:${item.uid}`,
                        label: `${modalData.product_name} (SN: ${item.serialName})`
                    });
                });
        } else if (modalData.tracking_inventory_type === "None" || !qrFor.includes("Serial/Batch Details")) {
            const quantity = parseInt(quantityAdjust, 10) || 0;
            for (let i = 0; i < quantity; i++) {
                qrData.push({
                    uid: `${modalData.pid}-QTY-${i + 1}`,
                    text: `Pid:${modalData.pid} | Pname:${modalData.product_name} | Ptype:${modalData.tracking_inventory_type}`,
                    label: `${modalData.product_name}`
                });
            }
        }

        if (qrData.length === 0) {
            alert("No QR codes to generate. Please select items.");
            return;
        }
        directPrintQRWithImage(qrData, pageSize);
    };

    return (
        <Modal show={displayModal} onHide={() => { handleProductQrModalClose() }} size="md" centered>
            <Modal.Header>
                <Modal.Title>{modalData.product_name}</Modal.Title>
                <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { handleProductQrModalClose() }}>
                    <span className="svg-icon svg-icon-1">
                        <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                            <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                            </g>
                        </svg>
                    </span>
                </div>
            </Modal.Header>
            <Modal.Body>
                {loading ?
                    <PageLoader />
                    :
                    <div
                        className="container"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "5px",
                            width: "100%",
                        }}
                    >
                        {/* Track Batches */}
                        {(modalData.tracking_inventory_type === "Track Batches" && stockInformation?.length > 0 && qrFor.includes("Serial/Batch Details")) && (
                            <div className="w-100">
                                <h5 className="mb-3">Batch-wise Quantity Adjustment</h5>
                                <div>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-light-success me-2"
                                        onClick={() => {
                                            const updated = stockInformation.map((item) => ({ ...item, checked: true }));
                                            setStockInformation(updated);
                                        }}
                                    >
                                        Check All
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-light-danger"
                                        onClick={() => {
                                            const updated = stockInformation.map((item) => ({ ...item, checked: false }));
                                            setStockInformation(updated);
                                        }}
                                    >
                                        Uncheck All
                                    </button>
                                </div>
                                {stockInformation.map((batch, index) => (
                                    <div
                                        key={index}
                                        className="d-flex justify-content-between align-items-center mb-2 border-bottom pb-2"
                                    >
                                        <div className="form-check me-3">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                checked={batch.checked || false}
                                                onChange={(e) => {
                                                    const updated = [...stockInformation];
                                                    updated[index].checked = e.target.checked;
                                                    setStockInformation(updated);
                                                }}
                                            />
                                        </div>
                                        <div className="flex-grow-1">
                                            <strong>Batch:</strong> {batch.Batch_Reference}
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <label className="me-2 mb-0">Qty:</label>
                                            <input
                                                type="number"
                                                min="0"
                                                value={batch.Quantity}
                                                className="form-control form-control-sm w-100px"
                                                onChange={(e) => {
                                                    const value = parseInt(e.target.value, 10);
                                                    const maxQty = batch.Quantity;

                                                    if (!isNaN(value) && value > 0 && value <= maxQty) {
                                                        const updated = [...stockInformation];
                                                        updated[index].Quantity = value;
                                                        setStockInformation(updated);
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}

                        {/* Track Serial Numbers */}
                        {modalData.tracking_inventory_type === "Track Serial Number" && stockInformation?.length > 0 && qrFor.includes("Serial/Batch Details") && (
                            <div className="w-100">
                                <h5 className="mb-3">Serial Numbers</h5>
                                <div>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-light-success me-2"
                                        onClick={() => {
                                            const updated = stockInformation.map((item) => ({ ...item, checked: true }));
                                            setStockInformation(updated);
                                        }}
                                    >
                                        Check All
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-light-danger"
                                        onClick={() => {
                                            const updated = stockInformation.map((item) => ({ ...item, checked: false }));
                                            setStockInformation(updated);
                                        }}
                                    >
                                        Uncheck All
                                    </button>
                                </div>
                                <ul className="list-group">
                                    {stockInformation.map((serial, index) => (
                                        <li key={index} className="list-group-item d-flex align-items-center">
                                            <input
                                                type="checkbox"
                                                className="form-check-input me-2"
                                                checked={serial.checked || false}
                                                onChange={(e) => {
                                                    const updated = [...stockInformation];
                                                    updated[index].checked = e.target.checked;
                                                    setStockInformation(updated);
                                                }}
                                            />
                                            {serial.serialName}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        {/* Simple Quantity */}
                        {(modalData.tracking_inventory_type === "None" || !qrFor.includes("Serial/Batch Details")) && (
                            <div className="w-100 text-center">
                                <h5 className="mb-3">Adjust Quantity</h5>
                                <input
                                    type="number"
                                    min="0"
                                    value={quantityAdjust || ""}
                                    onChange={(e) => {
                                        const value = parseInt(e.target.value, 10);
                                        if (!isNaN(value) && value > 0 && value <= modalData.available_stock) {
                                            setQuantityAdjust(e.target.value)
                                        }
                                    }}
                                    className="form-control form-control-lg w-50 mx-auto"
                                />
                            </div>
                        )}
                    </div>
                }
            </Modal.Body>
            <Modal.Footer>
                {/* <button
                    className="btn btn-secondary"
                    onClick={handleProductQrModalClose()}
                >
                    Close
                </button> */}
                {write &&
                    <button
                        className="btn btn-success"
                        onClick={handlePrintQR}
                        disabled={
                            (qrFor.includes("Serial/Batch Details") && modalData.tracking_inventory_type !== "None" &&
                                !stockInformation.some(obj => obj.checked))
                        }
                    >
                        <i className="bi bi-qr-code me-2"></i> Print QR
                    </button>}
            </Modal.Footer>
        </Modal>
    );
};
